import { ArticleCamFile } from './article-cam-file';

export class ArticleCam {
  constructor(
    public hash: string,
    public observations: string,
    public camFiles: ArticleCamFile[]
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/article-cam.ts